import * as types from '../types.js';

export default {
	html: `
		<form id="products-print-report" class="form" autocomplete="off">
			<datalist id="companies"></datalist>
			<datalist id="programs-prod-report"></datalist>
			<p class="fss">Exporta o cadastro completo de produtos da empresa (dados gerais e tributários).
				CSV: UTF-8 com BOM para abrir no Excel.
				Excel: planilha XLSX com cabeçalhos em português, filtros automáticos e primeira linha congelada.
				Chamados #MT-007B282 e #MT-7A50355.</p>
			<div class="fsb">
				<label title="Empresa">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Filtrar por programa">Programa
					<input id="program_id" type="text" list="programs-prod-report" placeholder="opcional">
				</label>
				<label title="Formato do arquivo de saída">Formato<sup>*</sup>
					<select id="format">
						<option value="xlsx">Excel (.xlsx)</option>
						<option value="csv">CSV (.csv)</option>
					</select>
				</label>
			</div>
			<div class="fsb">
				<label title="Ativos / inativos no cadastro">Situação
					<select id="status">
						<option value="all">Todos</option>
						<option value="active">Somente ativos</option>
						<option value="inactive">Somente inativos</option>
					</select>
				</label>
				<label title="Filtrar por SKU (parcial)">SKU (contém)
					<input id="sku" type="text" placeholder="opcional">
				</label>
				<label title="Filtrar por nome/descrição do produto (parcial)">Nome (contém)
					<input id="name" type="text" placeholder="opcional">
				</label>
				<label title="Limite de linhas">Máx. linhas
					<input id="max_rows" type="text" value="50000" placeholder="50000">
				</label>
			</div>
			<div class="fsb mtm">
				<span class="fss" style="color:#666;">
					Colunas: empresa, ids, categoria, fabricante, hierarquia (taxons), SKU, nome, sinônimos,
					descrição, referências, código cliente, programa, GTIN/EAN, NCM, CEST, origem, tributação,
					flags ICMS (ST/isento/monofásico/red.BC), alíquota ICMS, cBenef, Portaria 344, vida útil,
					estoques, valor, unidades, dimensões ES/ET, classes, Anvisa/PMC, inativo.
				</span>
				<span>
					<button type="button" class="bn_Escape button">Cancelar</button>
					<button type="submit" class="bn_Enter button">Gerar Relatório</button>
				</span>
			</div>
		</form>
	`,
	form: {
		selector: '#products-print-report',
		init(formset) {
			formset.loadList('#companies', 'companies', { labels: ['nick'] });
			Object.getPrototypeOf(this).init.call(this);
		},
	},
	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub(), types.datalist()] },
		{
			properties: { selector: '#program_id' },
			types: [
				types.pubsub(),
				types.datalist(),
				types.observer('company_id'),
				types.obs_load_options('programs', { labels: ['name'] }),
			],
		},
		{ properties: { selector: '#format' }, types: [] },
		{ properties: { selector: '#status' }, types: [] },
		{ properties: { selector: '#sku' }, types: [] },
		{ properties: { selector: '#name' }, types: [] },
		{ properties: { selector: '#max_rows' }, types: [types.number(0, 0)] },
	],
};
